import { render, staticRenderFns } from "./ContractDocumentsSection.vue?vue&type=template&id=c12b56b8&scoped=true"
import script from "./ContractDocumentsSection.vue?vue&type=script&lang=js"
export * from "./ContractDocumentsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12b56b8",
  null
  
)

export default component.exports